import React, {useState, useEffect} from 'react';
import {StyledProps} from '../../modules/common/styles';
import {StaticNavBar} from './static-nav';
import {HiddenNav} from './hidden-nav';
import {styled} from 'styled-components';

export interface StyleHiddenNavProps extends StyledProps {
    backgroundColor?: string /* Background color for the hidden part */;
    visibleByDefault?: boolean;
    changePoint?: number;
    children?: React.ReactNode /* To be rendered on the hidden part. If not provided no hidden part will be rendered */;
    currentPath: string;
}

const TransparentStaticNavBar = styled(StaticNavBar)`
    background-color: transparent;
    box-shadow: unset;
    padding: 0 1.5rem 0 0;
    position: absolute;
`;

/**
 * Component that renders the Nav with the hidden part.
 *
 */

export const Nav = (props: StyleHiddenNavProps): JSX.Element => {
    const {
        backgroundColor,
        visibleByDefault,
        changePoint,
        children,
        currentPath,
    } = props;

    const show = visibleByDefault || false;

    const [visible, setVisible] = useState<boolean>(show);
    const [firstIteration, setFirstIteration] = useState<boolean>(true);

    useEffect(() => {
        //We just listen to the scroll if a a changePoint and children is provided
        if (children && changePoint) {
            window.onscroll = onScrollHandler;
        }
        return () => {
            window.onscroll = null;
        };
        // eslint-disable-next-line
    }, [visible, changePoint]);

    const onScrollHandler = (): void => {
        if (
            changePoint &&
            window.pageYOffset > changePoint &&
            visible === show
        ) {
            setVisible(!show);
            setFirstIteration(false);
        } else if (
            changePoint &&
            window.pageYOffset <= changePoint &&
            visible !== show
        ) {
            setVisible(show);
            setFirstIteration(false);
        }
    };

    if (!children) {
        return <StaticNavBar longShadow={true} currentPath={currentPath} />;
    }

    return (
        <>
            <TransparentStaticNavBar
                longShadow={!visible}
                currentPath={currentPath}
            />
            <HiddenNav
                visible={visible}
                backgroundColor={backgroundColor}
                firstIteration={firstIteration}
            >
                {children}
            </HiddenNav>
        </>
    );
};
